"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHUnifiedInput = void 0;
const KHInputScene_1 = require("./KHInputScene");
const KHInputKeyOr_1 = require("./KHInputKeyOr");
const KHInputKeyConditional_1 = require("./KHInputKeyConditional");
const KHInputAxisDeadZoneScaledRadial_1 = require("./KHInputAxisDeadZoneScaledRadial");
const KHInputAxisHighestMagnitude_1 = require("./KHInputAxisHighestMagnitude");
const KHInputAxisDeadZoneScaledAxial_1 = require("./KHInputAxisDeadZoneScaledAxial");
class KHUnifiedInput {
    static UnifiedInput(inputSet, keys = [], buttons = [], mouseInputs = [], condtional = null, invert = false) {
        let inputs = [];
        inputs.push(...this.GetKeyboardInputs(keys));
        inputs.push(...this.GetControllerInputs(buttons));
        inputs.push(...this.GetMouseInputs(mouseInputs));
        let combinedInput = this.GetCombinedInput(inputSet, inputs);
        if (condtional == null) {
            return combinedInput;
        }
        return new KHInputKeyConditional_1.KHInputKeyConditional(inputSet, this.GetCombinedInput(inputSet, inputs), condtional, invert);
    }
    static GetKeyboardInputs(keys = []) {
        const keyboard = KHInputScene_1.KHInputScene.SharedInput.keyboardProvider;
        let inputs = [];
        for (let i = 0; i < keys.length; i++) {
            inputs.push(keyboard.getInput(keys[i]));
        }
        return inputs;
    }
    static GetControllerInputs(buttons = []) {
        const gamepad = KHInputScene_1.KHInputScene.SharedInput.controllerProviders;
        let inputs = [];
        for (let i = 0; i < buttons.length; i++) {
            for (let j = 0; j < gamepad.length; j++) {
                inputs.push(gamepad[j].getInput(buttons[i]));
            }
        }
        return inputs;
    }
    static GetControllerAxesScaledRadial(inputSet, primary, secondary, deadZone) {
        const gamepad = KHInputScene_1.KHInputScene.SharedInput.controllerProviders;
        let axes = [];
        for (let j = 0; j < gamepad.length; j++) {
            axes.push(new KHInputAxisDeadZoneScaledRadial_1.KHInputAxisDeadZoneScaledRadial(inputSet, deadZone, gamepad[j].getAxis(primary), gamepad[j].getAxis(secondary)));
        }
        return axes;
    }
    static GetControllerAxesScaledAxial(inputSet, primary, deadZone) {
        const gamepad = KHInputScene_1.KHInputScene.SharedInput.controllerProviders;
        let axes = [];
        for (let j = 0; j < 1; j++) {
            axes.push(new KHInputAxisDeadZoneScaledAxial_1.KHInputAxisDeadZoneScaledAxial(inputSet, deadZone, gamepad[j].getAxis(primary)));
        }
        return axes;
    }
    static GetMouseInputs(mouseInputs = []) {
        const mouse = KHInputScene_1.KHInputScene.SharedInput.mouseProvider;
        let inputs = [];
        for (let i = 0; i < mouseInputs.length; i++) {
            inputs.push(mouse.getInput(mouseInputs[i]));
        }
        return inputs;
    }
    static GetCombinedInput(inputSet, inputs = [], retriggerOnEveryJustDown = false) {
        return inputs.length == 1 ? inputs[0] : new KHInputKeyOr_1.KHInputKeyOr(inputSet, inputs, retriggerOnEveryJustDown);
    }
    static GetCombinedAxis(inputSet, axes = []) {
        return axes.length == 1 ? axes[0] : new KHInputAxisHighestMagnitude_1.KHInputAxisHighestMagnitude(inputSet, axes);
    }
}
exports.KHUnifiedInput = KHUnifiedInput;
